import { Factory } from "@/repository/Factory";
const Schedule = Factory.get("schedule");

const state = {
  gridSelectedRow: null,
  scheduleItems: []
};

const getters = {
  gridSelectedRow: state => state.gridSelectedRow
};

const mutations = {
  setScheduleItems: (state, payload) => {
    state.scheduleItems = JSON.parse(JSON.stringify(payload));
  },
  GRID_SELECT_ROW: (state, payload) => {
    state.gridSelectedRow = payload;
  }
};

const actions = {
  async getProjectSchedules({ commit }, payload) {
    return await Schedule.getProjectSchedules(payload).then(
      response => {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  async getProjectSchedule({ commit }, payload) {
    return await Schedule.getProjectSchedule(payload).then(
      response => {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  async getProjectScheduleLevels({ commit }, payload) {
    return await Schedule.getProjectScheduleLevels(payload).then(
      response => {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  async getProjectScheduleItemGroups({ commit }, payload) {
    return await Schedule.getProjectScheduleItemGroups(payload).then(
      response => {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  async getProjectScheduleItems({ commit }, payload) {
    commit("setScheduleItems", []);

    return await Schedule.getProjectScheduleItems(payload).then(
      response => {
        if (response.status === 200) {
          commit("setScheduleItems", response.data);
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },
  gridSelectRow: ({ commit }, payload) => {
    commit("GRID_SELECT_ROW", payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
